import { GiroPaymentsTableSortableField } from 'types/state';
import { M8StatementDTOSortableField } from 'services/production/types';
import { UnreachableError } from 'utils/errors';

export const normalizeGiroPaymentsTableSortableField = (
  field: GiroPaymentsTableSortableField
) => ({
  toM8StatementDTOSortableField(): M8StatementDTOSortableField {
    switch (field) {
      case 'id':
        return 'id';
      case 'unp':
        return 'unp';
      case 'organization':
        return 'user.organization';
      case 'fullName':
        return 'user.lastName';
      case 'recievedAmount':
        return 'amount';
      case 'creditedAmount':
        return 'billedAmount';
      case 'status':
        return 'statementStatus';
      case 'createdAt':
        return 'createdOn';
      case 'updatedAt':
        return 'updatedOn';
      case 'recievedAt':
        return 'acceptDate';
      default:
        throw new UnreachableError(field);
    }
  },
});
